import {
  DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_BEGIN,
  DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_SUCCESS,
  DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_FAILURE,
  DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function deleteSourceConnector(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_BEGIN,
    });

    const { projectId, sourceUuid, connectorUuid, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/data-connector/${sourceUuid}/connector/${connectorUuid}`;
      const doRequest = axios.delete(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteSourceConnectorError() {
  return {
    type: DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_BEGIN:
      return {
        ...state,
        deleteSourceConnectorPending: true,
        deleteSourceConnectorError: null,
      };

    case DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_SUCCESS:
      return {
        ...state,
        deleteSourceConnectorPending: false,
        deleteSourceConnectorError: null,
      };

    case DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_FAILURE:
      return {
        ...state,
        deleteSourceConnectorPending: false,
        deleteSourceConnectorError: action.data.error,
      };

    case DATA_CONNECTOR_DELETE_SOURCE_CONNECTOR_DISMISS_ERROR:
      return {
        ...state,
        deleteSourceConnectorError: null,
      };

    default:
      return state;
  }
}
